import { render, staticRenderFns } from "./VetNotesToggle.vue?vue&type=template&id=92b023bc&"
import script from "./VetNotesToggle.vue?vue&type=script&lang=js&"
export * from "./VetNotesToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports